export const btnStyles = {
  default: 'default',
  outline: 'outline',
  simple: 'simple'
}
